import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnME: CultureInfo = {
  name: 'en-ME',
  displayName: 'English (Montenegro)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-ME',
  parent: CultureInfoEn
};
